import {
  consultaInicial,
  executeFieldAction,
  selectCamposSolicitud,
  selectDatosSolicitud,
  setCampoValidando,
  setDatoSolicitud,
} from 'features/solicitudes/solicitudesSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { validate } from '../../libs/FieldResquestValidator'
import {
  getValoresConsulta,
  processValidationResult,
  todosLosPadresTienenValor,
} from '../../libs/SolicitudesHelpers'
import ValidatingText from '../ValidatingText'

import axios from 'api/axios'

import { Alert, Box, Skeleton } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import LabelComponent from '../LabelComponent'

function RadioComponent({ idpk }) {
  const dispatch = useDispatch()
  const campos = useSelector(selectCamposSolicitud)
  const campo = campos.filter((c) => c.idpk === idpk)[0]

  const datos = useSelector(selectDatosSolicitud)
  const valor = datos[campo.idpk]

  const [value, setValue] = useState('')
  const [options, setOptions] = useState([])
  const [lvLoading, setLvLoading] = useState(true)
  const [error, setError] = useState('')

  // La inicialización ahora se hace de forma centralizada en CamposSolicitud
  // mediante el endpoint /inicializasolicitud/

  useEffect(() => {
    if (options.length === 0) {
      setLvLoading(true)
      axios
        .post(`/consultalov/${idpk}/`, {
          valores: getValoresConsulta(datos, campos),
          busqueda: value,
        })
        .then((request_response) => {
          const data = request_response.data
          setOptions(data.registros)
        })
        .catch((error) => setError(error))
        .finally(() => setLvLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])

  useEffect(() => {
    if (campo.lovVersion > 0) {
      setOptions([])
      setValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campo.lovVersion])

  useEffect(() => {
    const processValueChange = async () => {
      // Si hay valor, validar primero
      if (valor) {
        try {
          // Activar estado de validación
          dispatch(setCampoValidando({ idpk: campo.idpk, validando: true }))

          const descripcion = options?.filter((o) => o.codigo === valor)[0]?.descripcion || ''
          const result = await validate(campo, valor, campos, datos)
          processValidationResult(result, campo, valor, dispatch, descripcion)
        } catch (error) {
          // Si hay error de validación, limpiar el campo y no ejecutar el resto
          setValue('')
          dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: null, descripcion: '' }))
          return
        } finally {
          // Desactivar estado de validación
          dispatch(setCampoValidando({ idpk: campo.idpk, validando: false }))
        }
      }

      setValue(valor)
      // Lanzamos las queries iniciales para campos dependientes solo si:
      // 1. El campo tiene valor
      // 2. El campo dependiente necesita inicialización (inicializando === 'P')
      // 3. El campo dependiente NO está siendo inicializado por inicializaSolicitud (inicializando !== 'R')
      campos.forEach((c) => {
        if (
          c.depende_de &&
          c.depende_de.includes(campo.codigo_campo) &&
          valor &&
          c.inicializando === 'P' &&
          todosLosPadresTienenValor(c, campos, datos)
        ) {
          dispatch(consultaInicial({ idpk: c.idpk, valores: getValoresConsulta(datos, campos) }))
        }
      })
      campo.acciones.forEach((action) => {
        if (
          action.valor_referencia === valor ||
          (action.valor_referencia === 'NOT_NULL' && valor) ||
          (action.valor_referencia === 'NULL' && !valor)
        ) {
          dispatch(executeFieldAction({ action }))
        }
      })
    }

    processValueChange()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valor])

  const handleChange = (e) => {
    const descripcion = options.filter((o) => o.codigo === e.target.value)[0].descripcion
    dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: e.target.value, descripcion }))
  }

  if (campo) {
    if (lvLoading) {
      return (
        <FormControl>
          <FormLabel sx={{ display: 'none' }} id={`r-${campo.idpk}`}>
            {campo.etiqueta}
          </FormLabel>
          <LabelComponent text={campo.etiqueta} obligatorio={campo.obligatorio} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="circular" width={25} height={25} />
              <Skeleton variant="rounded" width={180} height={20} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="circular" width={25} height={25} />
              <Skeleton variant="rounded" width={180} height={20} />
            </Box>
          </Box>
        </FormControl>
      )
    } else {
      return error ? (
        <Alert>Error cargando los datos</Alert>
      ) : (
        <FormControl
          required={campo.obligatorio === 'S'}
          disabled={campo.informativo === 'S' || campo.validando}
        >
          <FormLabel sx={{ display: 'none' }} id={`r-${campo.idpk}`}>
            {campo.etiqueta}
          </FormLabel>
          <LabelComponent text={campo.etiqueta} obligatorio={campo.obligatorio} />
          <RadioGroup
            row
            aria-labelledby={campo.etiqueta}
            name={campo.codigo_campo}
            value={value}
            onChange={handleChange}
            color={campo.error ? 'error' : ''}
          >
            {options.map((o) => (
              <FormControlLabel
                key={o.codigo}
                value={o.codigo}
                control={<Radio />}
                label={o.descripcion}
              />
            ))}
          </RadioGroup>
          <FormHelperText>{campo.validando ? <ValidatingText /> : campo.ayuda}</FormHelperText>
        </FormControl>
      )
    }
  }
}

export default RadioComponent
